import { useToast } from "@/ds";
import { createExportFeedback, useFileExport } from "@/modules/export";
import { exportPlanejamentoControle } from "@/modules/financeiro-obras";
import { EXPORTACAO_FILE_NAME } from "./planejamento-controle.constants";

export function useExportarPlanejamento(obraId: string) {
  const toast = useToast();

  return useFileExport({
    fileName: EXPORTACAO_FILE_NAME,
    loadFile: (format) => exportPlanejamentoControle(obraId, format),
    ...createExportFeedback(toast),
  });
}
